<div class="captura-biometrica" id="frame">
    <div class="captura">
        <div id="box-camera"></div>
    </div>
</div>